import { createSlice } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

// Slice
const communicationTemplatesSlice = createSlice({
  name: 'communicationTemplates',
  initialState: initialStore.communicationTemplates,
  reducers: {
    getCommunicationTemplates: (state) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setCommunicationTemplates: (state, { payload }) => {
      state.isLoading = false;
      state.communicationTemplates = payload;
    },
    failAction: (state) => {
      state.isLoading = false;
    }
  }
});

export const {
  getCommunicationTemplates,
  setCommunicationTemplates,
  failAction
} = communicationTemplatesSlice.actions;

export const { reducer } = communicationTemplatesSlice;

// Selectors
export const getCommunicationTemplatesSelector = (state: IState) =>
  state && state.communicationTemplates.communicationTemplates;

export const getCommunicationTemplatesLoadingSelector = (state: IState) =>
  state && state.communicationTemplates.isLoading;
